// default toolbar options can be found here:
// https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
const defaultToolbar = [
  ['bold', 'italic', 'underline'], // toggled buttons
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
]
export default defaultToolbar
